module.exports = __webpack_public_path__ + "img/b2.110fbfcf.png";